module.exports = __webpack_public_path__ + "img/symbol_6.b9b64c0f.png";